jQuery(document).ready(function ($) {
    $('.block--lux-faqs-search input').on('input', function () {
        const s = $(this).val().toLowerCase();
        $('.block--lux-faqs .faq').each(function () {
            if ($(this).find('.faq-question').text().toLowerCase().includes(s) || s === '') {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        $('.block--lux-faqs').each(function () {
            if ($(this).find('.faq').filter(function () {
                return $(this).css('display') === 'block';
            }).length) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        if ($('.block--lux-faqs').filter(function () {
            return $(this).css('display') === 'block';
        }).length) {
            $('.block--lux-faqs-search .notFound').hide();
        } else {
            $('.block--lux-faqs-search .notFound').show();
        }
    });
});
